import 'svgxuse';
import 'focus-visible';
import ObjectFit from './modules/object-fit';
import MatchMedia from './modules/matchMedia';
import AddNoopener from './modules/add-noopener';
import Smoothscroll from './modules/smooth-scroll';
import ObserveTarget from './modules/observe-target';
import Hamburger from './modules/hamburger';
import Accordion from './modules/accordion';
import Tab from './modules/tab';
import Modal from './modules/modal';

class Index {
  constructor() {
    new ObjectFit();
    new MatchMedia();
    new AddNoopener();
    new Smoothscroll();
    new ObserveTarget();
    new Hamburger();
    new Accordion();
    new Tab();
    new Modal();
  }
}

export default new Index();
